import React from 'react';
import { useSelector } from 'react-redux';
import { isValidArrayLength } from '@nykaa/utils/validations';
import styled from 'App/styled';
import { State } from 'store/types';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 83%;
  margin: ${({ theme }) => `${theme.spacing.spacing0} auto`};
  margin-top: ${({ theme }) => theme.spacing.spacing100};
  margin-bottom: ${({ theme }) => theme.spacing.spacing100};
`;

const Row = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.spacing100};
`;
const Heading = styled.strong`
  text-transform: capitalize;
  ${({ theme }) => theme.typography.titleXSmall};
  margin: ${({ theme }) =>
    `${theme.spacing.spacing80} ${theme.spacing.spacing0} ${theme.spacing.spacing50}`};
  color: ${(props) => props.theme.footerLinks};
`;

export const Item = styled.li`
  margin-bottom: ${({ theme }) => theme.spacing.spacing0};
  padding-right: ${({ theme }) => theme.spacing.spacing20};
  display: inline;
  line-height: 20px;
`;

export const Anchor = styled.a`
  text-transform: capitalize;
  color: ${(props) => props.theme.footerLinks};
  ${({ theme }) => theme.typography.bodyMedium};
  text-decoration: none;
`;

export const Dot = styled.div`
  height: 4px;
  width: 4px;
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  background: ${({ theme }) => theme.colors.textSecondary};
  display: inline-flex;
  margin: ${({ theme }) =>
    `${theme.spacing.spacing10} ${theme.spacing.spacing20}`};
`;

const isLast = (index: number, length: number) => index + 1 === length;

function DynamicFooterLinks() {
  const relatedLinks = useSelector((state: State) => state.footer.relatedLinks);
  if (isValidArrayLength(relatedLinks)) {
    return (
      <Wrapper>
        <Row>
          <Heading>Related Categories</Heading>
          <ul>
            {relatedLinks.map((item, index) => {
              const char = isLast(index, relatedLinks.length) ? '' : ',';
              return (
                <Item key={`cat_sect_li${item?.keyword}`}>
                  <Anchor href={item?.url}>{`${item?.keyword}${char}`}</Anchor>
                </Item>
              );
            })}
          </ul>
        </Row>
      </Wrapper>
    );
  }
  return null;
}

export default DynamicFooterLinks;
